"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eye = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var eye = function eye(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'eye-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M0.0619922 9.79209C1.62387 5.82872 5.48017 3.01714 9.99967 3.01714C14.5192 3.01714 18.3755 5.82872 19.9373 9.79209C20.007 9.9688 20.007 10.1653 19.9373 10.342C18.3755 14.3054 14.5192 17.117 9.99967 17.117C5.48017 17.117 1.62387 14.3054 0.0619922 10.342C-0.00764322 10.1653 -0.00764322 9.9688 0.0619922 9.79209ZM1.57109 10.0671C2.98213 13.3328 6.22435 15.617 9.99967 15.617C13.775 15.617 17.0172 13.3328 18.4282 10.0671C17.0172 6.80135 13.775 4.51714 9.99967 4.51714C6.22435 4.51714 2.98213 6.80135 1.57109 10.0671Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M10 7.74998C8.75736 7.74998 7.75 8.75734 7.75 9.99998C7.75 11.2426 8.75736 12.25 10 12.25C11.2426 12.25 12.25 11.2426 12.25 9.99998C12.25 8.75734 11.2426 7.74998 10 7.74998ZM6.25 9.99998C6.25 7.92892 7.92893 6.24998 10 6.24998C12.0711 6.24998 13.75 7.92892 13.75 9.99998C13.75 12.0711 12.0711 13.75 10 13.75C7.92893 13.75 6.25 12.0711 6.25 9.99998Z',
    fill: '#4B5563'
  }));
};

exports.eye = eye;